import { PaymentMethod } from '~/shared/constants/paymentConstants'
import {
  selectPrimerApplePayProcessorName,
  selectPrimerGooglePayProcessorName,
  selectPrimerPaypalProcessorName,
  selectPrimerProcessorName,
} from '~/shared/store/payment/selects'
import { IAppState } from '~/shared/store/types'

export interface IPaymentProcessorNames {
  processorName: string
  applePayProcessorName: string
  googlePayProcessorName: string
  paypalProcessorName: string
}

export const pickPaymentProcessorName = (
  names: IPaymentProcessorNames,
  paymentMethod?: PaymentMethod,
): string => {
  switch (paymentMethod) {
    case PaymentMethod.APPLE_PAY:
      return names.applePayProcessorName
    case PaymentMethod.GOOGLE_PAY:
      return names.googlePayProcessorName
    case PaymentMethod.PAYPAL:
      return names.paypalProcessorName
    default:
      return names.processorName
  }
}

export const getPaymentProcessorName = (
  state: IAppState,
  paymentMethod?: PaymentMethod,
): string =>
  pickPaymentProcessorName(
    {
      processorName: selectPrimerProcessorName(state),
      applePayProcessorName: selectPrimerApplePayProcessorName(state),
      googlePayProcessorName: selectPrimerGooglePayProcessorName(state),
      paypalProcessorName: selectPrimerPaypalProcessorName(state),
    },
    paymentMethod,
  )
